import { styled } from '@mui/material/styles';

export const slickDotsClass = 'slick-dots-custom';

interface SlickDotsProps {
    bottom?: number;
    color?: string;
    slideGap?: boolean;
}

export const SlickDots = styled('div', {
  shouldForwardProp: (prop) => prop !== 'bottom' && prop !== 'color' && prop !== 'slideGap'
}) <SlickDotsProps> (({ bottom = 10, color = '#000', slideGap }) => ({
  [`& .${slickDotsClass}`]: {
    bottom,
    '& li.slick-active button::before': {
      fontSize: '0.625rem',
      color,
      opacity: 1,
      borderRadius: '50%'
    },
    '& li button::before': {
      fontSize: '0.375rem',
      color,
      opacity: 0.5,
      borderRadius: '50%'
    }
  },
  ...(slideGap && {
    '& .slick-slide': {
      padding: '0 5px'
    }
  })
}));